import { Box, Flex, Heading, Text, Dialog, IconButton } from '@radix-ui/themes';
import { ResumeChooserView } from './ApplyJobSelectForm';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'shared/icons';

export function ResumeChooser({ jobTitle, ...props }: any) {
   const { t } = useTranslation('global');
   return (
      <>
         <Flex mb="5" width="100%" justify="between">
            <Box>
               <Heading as="h2" mb="1" weight="medium">
                  {t('jobDescription.jobApplyTitle')}:
               </Heading>
               <Text color="indigo" highContrast size="4">
                  {jobTitle}
               </Text>
            </Box>
            <Dialog.Close>
               <IconButton size="1" color="blue" highContrast variant="soft" radius="full">
                  <CloseIcon />
               </IconButton>
            </Dialog.Close>
         </Flex>
         <ResumeChooserView {...props} />
      </>
   );
}
